// extracted by mini-css-extract-plugin
module.exports = {"editableLabel":"EditableLabel_editableLabel__ySj9D"};